import React from 'react';
import { Input } from 'semantic-ui-react';

const ShortText = ({
  field,
  fieldValue = '',
  updateIdea,
  isEditing,
  inputRef,
  handleKeyDown,
}) => {
  if (!isEditing) return <h4>{fieldValue}</h4>;
  return (
    <div>
      <Input
        size="large"
        fluid
        value={fieldValue}
        onChange={e => updateIdea(e.target.value, ['templated', field.id])}
        ref={inputRef}
        onKeyDown={event => handleKeyDown(event)}
      />
    </div>
  );
};

export default ShortText;
